import apiRequest from './client';

// Historique des transferts de POS entre groups. Company : ses propres transferts.
// Superadmin : tous, filtrable par ?company=<nom> et ?bank=<id>.
export const fetchGroupTransfers = ({ company, bank } = {}) => {
  const qs = [];
  if (company) qs.push(`company=${encodeURIComponent(company)}`);
  if (bank) qs.push(`bank=${encodeURIComponent(bank)}`);
  return apiRequest(`/group-transfers/${qs.length ? `?${qs.join('&')}` : ''}`);
};

// Deplace un bank vers un autre group (trace le transfert). group = id ou null.
export const moveBankToGroup = (bankId, group, note = '') =>
  apiRequest(`/banks/${bankId}/move_group/`, { method: 'POST', body: { group, note } });
